import usePanelStats from "../../../../core/hooks/main/panel/usePanelStats";
import Select from "../../../common/dropdown/Select";
import {useState} from "react";
import {PERIODS} from "../../../../core/constants/panel";
import {DText, Flex} from "../../../../styles/CommonStyles";
import {ScaleLoader} from "react-spinners";
import {ModalHeader} from "../../../../styles/modals";
import Text from "../../../../core/utils/Text";
import PanelBarChart from "../PanelBarChart";


const OrdersPanel = () => {

    const { data } = usePanelStats('order')
    const [period, setPeriod] = useState('total')

    return (
        <>
            <ModalHeader style={{ marginBottom: '10px', padding: '8px 0' }}>
                <DText main>
                    <Text tid={'orders'} />
                </DText>
            </ModalHeader>
            <Flex fw justify={'flex-start'} style={{ marginBottom: '10px' }}>
                <DText main fontSize={'s'} style={{ margin: '0 5px' }}>
                    <Text tid={'period'} /> :
                </DText>
                <Select
                    width={'180px'}
                    options={PERIODS}
                    value={period}
                    onValueChange={(idx) => setPeriod(PERIODS[idx])}
                    height={'42px'}
                    fontSize={'s'}
                />
            </Flex>
            {!data &&
                <Flex fw height={'300px'}>
                    <ScaleLoader
                        color={'#9F9181'}
                        height={26}
                        width={3}
                    />
                </Flex>
            }

            <div style={{ direction: 'ltr', overflow: 'auto' }}>
                {data &&
                    <PanelBarChart
                        data={data}
                        period={period}
                    />
                }
            </div>
        </>

    )
}

export default OrdersPanel
